import { useCheditor } from '@/utils'
import { Button, Form, Input, message, Select, Upload, Radio, Typography, Space } from 'antd'
import { useEffect, useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { useGetAttachments, useGetPhishingPages, usePutEmail } from './utils'
import { readEml } from 'eml-parse-js'
import { GetAttachments, GetPhishingPages } from '@/api/template'
import { useDebounceFn } from 'ahooks'
import { Message } from '@/components/message'
import { t } from '@/i18n'
const { Option } = Select
const { useForm } = Form
export const EditEmail = props => {
  const [form] = useForm()
  const [putEmail] = usePutEmail()
  let [element, setElement] = useState<HTMLDivElement | null>(null)
  const { particulars, submit, id, acquire } = props
  let [content, setContent] = useState('')
  const { editor } = useCheditor({
    height: 270,
    initData: particulars.content,
    element,
    // onKey: e => {
    //   run(e)
    // },
    onChange: e => {
      run(e)
    },
  })
  useEffect(() => {
    if (particulars.content) {
      const value = particulars.content
      setContent(value)
      form.setFieldsValue({ ...particulars, link: '{{.Url}}' })
      console.log('particulars', particulars)
      // const regs = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/gim
      // setResList((resList = value.match(regs)))
      // if (!value.match(regs) || value.match(regs)?.length === 0) {
      //   form.setFieldsValue({ link: undefined })
      // }
      const regs = /<a .*?href="(.*?)">.*?<\/a>/gim
      setResList(value.match(regs))
      if (!value.match(regs) || value.match(regs)?.length === 0) {
        form.setFieldsValue({ link: undefined })
      }
    }
  }, [particulars.content])
  useEffect(() => {
    if (submit.accomplish) {
      form.submit()
    }
  }, [submit])
  const { run } = useDebounceFn(
    value => {
      setContent(value)
      // const regs = /<a .*?href="(.*?)">.*?<\/a>/gim
      // setResList((resList = value.match(regs)))
      // if (!value.match(regs) || value.match(regs)?.length === 0) {
      //   form.setFieldsValue({ link: undefined })
      // }
      // replaceFn(value)
      const regs = /<a .*?href="(.*?)">.*?<\/a>/gim
      setResList(value.match(regs))
      if (!value.match(regs) || value.match(regs)?.length === 0) {
        form.setFieldsValue({ link: undefined })
      }
    },
    {
      wait: 500,
    },
  )

  const replaceFn = value => {
    if (value?.indexOf('window.location.replace') > 0) {
      value = value?.replaceAll('window.location.replace', 'let  ddd')
      editor?.setData(value)
    }
    if (value?.indexOf('window.location.href') > 0) {
      value = value?.replaceAll('window.location.href', 'let  ddd')
      editor?.setData(value)
    }
    if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
      let arr = value.split('<script')
      arr.map(() => {
        if (value?.indexOf('<script') > 0 && value.indexOf('</script>') > 0) {
          value = value?.replaceAll(
            value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
            '',
          )
        }
      })
      editor?.setData(value)
    }
  }
  useEffect(() => {
    let value = editor?.getData()
    // replaceFn(value)
  }, [editor?.getData()])
  const [getPhishingParams, setGetPhishingParams] = useState<GetPhishingPages>({
    limit: 9999999,
    page: 1,
    name: '',
  })

  const [getAttachmentParams, setGetAttachmentParams] = useState<GetAttachments>({
    limit: 9999999,
    page: 1,
    name: '',
  })
  const [getPhishingPages, getPhishing] = useGetPhishingPages({
    GetPhishingParams: getPhishingParams,
  })
  const [getAttachments, getAttachmentsList] = useGetAttachments({
    GetAttachmentsParams: getAttachmentParams,
  })
  const onFinish = (values: any) => {
    const { name, subject, sender, emailType, link, templateId } = values
    let value = editor?.getData()
    // if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
    //   let arr = value.split('<script')
    //   arr.map(() => {
    //     // value.substring(value.indexOf('<script>'), value.indexOf('</script>'))
    //     if (value.indexOf('<script') > 0 && value.indexOf('</script>') > 0) {
    //       value = value.replaceAll(
    //         value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
    //         '',
    //       )
    //     }
    //   })
    let arr = []
    // }
    resList?.map(item => {
      const reg2 = /href=\"([^\"]+)/gim
      const reg3 = />(.*)<\/a>/gim
      const reg4 = /(?<=>)(.|\s)*?(?=<\/?\w+[^<]*>)/gim
      const links = item.match(reg2)
      const urls = links?.[0]?.slice(links?.[0]?.indexOf('=') + 2)
      if (urls === values.link) {
        value = value.replaceAll(urls, `{{.Url}}`)
        arr.push(item.match(reg3)[0].match(reg4).join(''))
      }
    })
    putEmail({
      id,
      name,
      subject,
      sender,
      content: value,
      email_type: particulars?.email_type,
      cover: '/static/default/phishEmail.png',
      link: particulars.link,
      template_id: templateId,
    })
      .then(res => {
        acquire(true)
      })
      .catch(err => {})
  }
  const onFinishFailed = (errorInfo: any) => {}

  let [templatetype, setTemplatetype] = useState(particulars?.email_type)
  let [resList, setResList] = useState([])
  let [phishing, setPhishing] = useState([])
  return (
    <div>
      {particulars && (
        <FormItem
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            name: particulars?.name,
            subject: particulars?.subject,
            sender: particulars?.sender || '',
            templateId: particulars?.template_id === '0' ? null : particulars?.template_id,
          }}
        >
          <Form.Item
            name="name"
            label="模板名称"
            rules={[
              { required: true, message: '请输入模板名称' },
              { max: 30, message: '模板名称最多30个字符' },
              {
                pattern: /^(?=.*\S).+$/,
                message: '模板名称不能全部为空格!',
              },
            ]}
          >
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item name="emailType" label="邮件模板类型">
            <div className="email">{particulars?.email_type === 1 ? '钓鱼链接' : '恶意附件'}</div>
          </Form.Item>
          <Form.Item label="发件地址">
            <div className="email">sender@seeattack.com</div>
          </Form.Item>
          <Form.Item name="sender" label="发件昵称" rules={[{ max: 64 }]}>
            <Input placeholder="请输入" maxLength={64} />
          </Form.Item>
          <div className="subject">
            <Form.Item
              name="subject"
              label="邮件主题"
              className="main_body"
              rules={[{ required: true }, { max: 100, message: '邮件主题最多100字' }]}
            >
              <Input placeholder="请输入邮件主题" maxLength={100} />
            </Form.Item>
            <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '25px' }}>
              <Upload
                name="image"
                listType="picture"
                maxCount={1}
                onChange={e => {
                  if (e.file?.status === 'error') {
                    // Message.error('导入失败')
                  } else if (e.file?.status === 'done') {
                  }
                }}
                beforeUpload={file => {
                  const reg = /\.(eml)$/
                  if (reg.test(file.name)) {
                    const reader = new FileReader()
                    reader.readAsText(file, 'utf8')
                    reader.onload = result => {
                      let targetNum = result.target.result
                      editor.setData(readEml(targetNum).html)
                    }
                    return true
                  }
                  Message.error('仅支持上传eml格式文件')
                  return false
                }}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />} style={{ marginLeft: '10px' }} type="primary">
                  {t('导入EML')}
                </Button>
              </Upload>
              <span style={{ fontSize: '12px', marginLeft: '8px', color: '#999999' }}>
                {t('只能上传utf-8格式')}
              </span>
            </div>
          </div>
          <div>
            <span style={{ color: '#ff4d4f', width: 11 }}>*</span>
            <span>{t('邮件正文')}</span>
          </div>
          {particulars.content && (
            <div style={{ width: '100%', marginTop: 8 }}>
              <div ref={setElement} />
            </div>
          )}
          {templatetype === 1 && (
            <>
              {resList && (
                <Form.Item
                  label="请选择更改为钓鱼页的链接"
                  name="link"
                  className="phishing"
                  rules={[{ required: true }]}
                >
                  <Radio.Group disabled>
                    <Space direction="vertical">
                      {resList?.map((item, index) => {
                        const reg2 = /href=\"([^\"]+)/gim
                        const reg3 = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/gim
                        const reg4 = /(?<=>)(.|\s)*?(?=<\/?\w{0,}[^<]*>)/gim
                        const link = item.match(reg2)
                        // const urls = link?.[0]?.slice(link?.[0]?.indexOf('=') + 2)
                        const urls = '{{.Url}}'
                        const url = item.match(reg3)
                        console.log('urls', urls)
                        console.log('url', url)
                        return (
                          // <div key={index}>
                          //   {url[0].match(reg4)?.join('') || link}：{'{{Url}}'}
                          // </div>
                          <Radio key={index} value={urls}>
                            <Typography.Text style={{ width: 200 }} ellipsis>
                              {url[0].match(reg4)?.join('')}
                            </Typography.Text>
                          </Radio>
                        )
                      })}
                    </Space>
                  </Radio.Group>
                </Form.Item>
              )}
              {phishing && (
                <Form.Item
                  name="templateId"
                  label="请选择钓鱼页模板"
                  // rules={[{ required: true, message: '请选择钓鱼页模板' }]}
                  className="template"
                >
                  <Select placeholder="请选择">
                    {getPhishing?.items?.length > 0 &&
                      getPhishing?.items?.map(item => (
                        <Option value={item?.id} key={item?.id}>
                          {item?.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              )}
            </>
          )}
          {templatetype === 2 && (
            <Form.Item
              name="templateId"
              label="请选择附件模板"
              // rules={[{ required: true, message: '请选择附件模板' }]}
            >
              <Select placeholder="请选择">
                {getAttachmentsList?.items?.map(item => (
                  <Option value={item?.id} key={item?.id}>
                    {item?.attachment_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </FormItem>
      )}
    </div>
  )
}

const FormItem = styled(Form)`
  padding-right: 30px;
  .subject {
    display: flex;
    width: 100%;
  }
  .ant-form-item-label {
    width: 120px;
    text-align: left;
  }
  .ant-input {
    width: 356px;
  }
  .ant-row {
    flex-wrap: nowrap;
  }
  .email {
    width: 356px;
    height: 32px;
    line-height: 32px;
    background-color: #f7f8fa;
    padding-left: 16px;
    margin: 0;
    color: #333333;
    border-radius: 6px;
  }
  .phishing {
    display: block;
    .ant-form-item-label {
      width: auto;
      text-align: left;
    }
  }
  .template {
    .ant-form-item-label {
      width: 150px;
      text-align: left;
    }
    .ant-form-item-control-input {
      width: 400px;
    }
  }
  .ant-row {
    display: block;
  }
`
